import React from 'react';

import { FieldComponent, FieldLocator, isPhoneField } from '@app/common/configurable-wizards';
import { PhoneField } from '@app/common/configurable-wizards/fields/Phone';
import { MaskedTextFieldFragment } from '@app/common/configurable-wizards/queries/queryTyping/all-fields';

import { INTL_NUMBER_FORMAT } from '../constants';

import { InternationalPhoneField } from '../InternationalPhone/InternationalPhoneField';

export const GenericPhoneFieldComponent: FieldComponent<MaskedTextFieldFragment> = ({ field, ...props }) => {
  const Component = field.maskFormat === INTL_NUMBER_FORMAT
    ? InternationalPhoneField
    : PhoneField;

  return (
    <Component
      field={field}
      {...props}
    />
  );
};

export const GenericPhoneFieldLocator: FieldLocator = ({ field }) => (
  isPhoneField(field)
    ? GenericPhoneFieldComponent
    : undefined
);
